import * as React from "react";
import { z } from "zod";
import styled from "styled-components";
import { ArticleMastheadBladeSchema } from "../../../schemas/blades/ArticleMasthead";
import { Blade } from "../../../components/Blade";
import { MediaImage } from "../../../components/Media";
import { RichText } from "../../../components/RichText";
import { RelativeFormattedDate } from "../../../components/RelativeFormattedDate/components/RelativeFormattedDate";
import { Icon } from "../../../components/Icon";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { BladeContent } from "../../../components/BladeContent";
import { ContentEngagement } from "../../../components/ContentEngagement";
export const ArticleMastheadContractSchema = ArticleMastheadBladeSchema.extend({
    type: z.literal("articleMasthead"),
});
const _ArticleMasthead = (props) => {
    const { banner, title, publishDate, description, category, tags, authors, socialLinks, ...otherProps } = props;
    return (React.createElement(Blade, { ...otherProps },
        React.createElement("div", { className: "banner" },
            React.createElement(Backdrop, null,
                React.createElement(BackdropBackground, null,
                    React.createElement(MediaImage, { className: "background-image", media: banner, role: "presentation" }))),
            React.createElement(BladeContent, { width: "medium" },
                React.createElement(MediaImage, { className: "banner-image", "data-testid": "banner-image", media: banner }))),
        React.createElement(BladeContent, { width: "medium" },
            React.createElement("div", { className: "content-container" },
                React.createElement("div", { className: "header" },
                    React.createElement("h1", { "data-testid": "title", className: "title" }, title),
                    description && React.createElement(RichText, { "data-testid": "tagline", ...description })),
                React.createElement("div", { className: "divider" }),
                React.createElement("div", { className: "metadata-with-links" },
                    React.createElement("div", { className: "metadata" },
                        category && (React.createElement(ContentEngagement, { "data-testid": "category", action: category.action, contentAnalytics: {
                                id: "article-masthead-category-link",
                                title: category.title,
                                uiType: "link",
                            } }, category.title)),
                        authors !== null && authors !== undefined && authors.length > 0 && (React.createElement("div", { className: "authors" },
                            React.createElement("span", null, authors?.map((author) => author.name).join(", ")))),
                        publishDate && React.createElement(RelativeFormattedDate, { className: "publish-date", date: publishDate })),
                    React.createElement("div", { className: "social-links" }, socialLinks?.map((link) => link.iconName &&
                        link.link?.action && (React.createElement(ContentEngagement, { key: link.iconName, action: link?.link?.action, contentAnalytics: {
                            id: `article-masthead-social-link-${link?.iconName}`,
                            title: link.link?.title,
                            uiType: "iconLink",
                            action: link.link.action,
                        } },
                        React.createElement(Icon, { name: link.iconName, key: link.iconName }))))))))));
};
export const ArticleMasthead = styled(_ArticleMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=ArticleMasthead.js.map